import { ClientBabel, JSBridge } from "mta-jsbridge";
import type {
  ListenerTypeMap,
  JSBTypeSyncMap,
  BabelExecAsyncMap,
  BabelListener
} from "~/submodule/utils/jsb/types";
const { env } = useConfig();

export const jsb: JSBridge<JSBTypeSyncMap, ListenerTypeMap> | undefined = isClient()
  ? new JSBridge({ debug: ["TEST", "PRE"].includes(env) })
  : undefined;

export const babel: ClientBabel<BabelExecAsyncMap, BabelListener> | undefined = isClient()
  ? new ClientBabel({ debug: ["TEST", "PRE"].includes(env) })
  : undefined;
